import { Group, UnstyledButton } from "@mantine/core";

import styles from "./NarrativeFooter.module.css";

export interface NarrativeFooterProps {
    /** Left decline affordance, available throughout (task 1.19). */
    onDecline?: () => void;
    declineLabel?: string;
    /** Disable the decline affordance — in-flight (double-submit guard) or training-mode (inert). */
    declineDisabled?: boolean;
    /** Quick-rebuttal affordance (outlined). */
    onQuickRebuttal?: () => void;
}

/**
 * The Long Form AI sale-action footer — `Declined` · `Quick rebuttal`. Enrollment is the final
 * "Enroll" stage of the narrative rail, not a footer button (design: Ricardo 2026-08-26), so the
 * footer carries only the always-available decline + quick-rebuttal affordances. Presentational and
 * self-contained (no fixed positioning); `NarrativeContainer` pins it to the bottom.
 */
export const NarrativeFooter = ({
    onDecline,
    declineLabel = "Declined",
    declineDisabled = false,
    onQuickRebuttal,
}: NarrativeFooterProps) => (
    <Group justify="space-between" align="center" gap="sm" className={styles.footer}>
        <UnstyledButton className={styles.decline} onClick={onDecline} disabled={declineDisabled}>
            {declineLabel}
        </UnstyledButton>

        <UnstyledButton className={styles.quickRebuttal} onClick={onQuickRebuttal}>
            Quick rebuttal
        </UnstyledButton>
    </Group>
);
